import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';
import { h } from '@stencil/core';

import RelatedProducts from './RelatedProducts/RelatedProducts.jsx';
import { RelatedGroups } from './RelatedGroups/RelatedGroups.jsx';

/**
 * @typedef {import('../../../../stores/data/RelatedProducts/RelatedSectionStore').RelatedSectionStore} RelatedSectionStore
 */

/**
 * @param {object} props
 * @param {string} props.skuID
 * @param {string} props.skuCommRef
 * @param {RelatedSectionStore} props.relatedStore
 * @param {*} props.labelsStore
 */

export const _RelatedSection = (props) => {
  const { skuID, relatedStore, labelsStore, skuCommRef } = props;
  // eslint-disable-next-line camelcase
  const { giftlistRelatedSectionTitle } = labelsStore;
  const titleContent = giftlistRelatedSectionTitle.replace('#related product name#', skuCommRef);

  return (
    <>
      {relatedStore.isReady
        ? (
          <div className="related-section">
            <p className="related-section__title">
              <span className="pes-text--colon">{titleContent}</span>
            </p>
            <RelatedGroups relatedStore={relatedStore} />
            <RelatedProducts products={relatedStore.products} parentSkuID={skuID} />
          </div>
        ) : ''}
    </>
  );
};

_RelatedSection.propTypes = {
  skuID: propTypes.string.isRequired,
  skuCommRef: propTypes.string.isRequired,

  relatedStore: propTypes.shape({
    isReady: propTypes.bool.isRequired,
    relatedGroups: propTypes.array.isRequired,
    products: propTypes.array.isRequired
  }).isRequired,

  labelsStore: propTypes.shape({
    giftlistRelatedSectionTitle: propTypes.string.isRequired
  }).isRequired
};

export const RelatedSection = inject((allStores, props) => ({
  relatedStore: allStores.relatedRootStore.getRelatedSectionStore(props.skuID),
  labelsStore: allStores.labelsStore
}))(observer(_RelatedSection));
